export default "<p>income-summary works!</p>\n"